import { tAny } from '@/i18n'
import { formatDate } from '@/utils/format'
import type { CoverKind, CoverStatus, DutyStatus, LessonSubject } from './types'

/** "Class teacher duties" or the subject name. */
export function dutyLabel(kind: CoverKind, subject: LessonSubject | null): string {
  return kind === 'section' ? tAny('Class teacher duties') : (subject?.name ?? tAny('Lessons'))
}

/** "12 Oct 2026" for a single day, "12 Oct 2026 → 16 Oct 2026" otherwise. */
export function dateRange(start: string, end: string): string {
  return start === end ? formatDate(start) : `${formatDate(start)} → ${formatDate(end)}`
}

export const coverStatusTone: Record<CoverStatus, 'brand' | 'info' | 'neutral'> = {
  active: 'brand',
  upcoming: 'info',
  ended: 'neutral',
}

export const coverStatusLabel: Record<CoverStatus, string> = {
  active: 'In progress',
  upcoming: 'Upcoming',
  ended: 'Ended',
}

export const dutyStatusTone: Record<DutyStatus, 'success' | 'warning' | 'danger'> = {
  covered: 'success',
  partial: 'warning',
  uncovered: 'danger',
}

export const dutyStatusLabel: Record<DutyStatus, string> = {
  covered: 'Covered',
  partial: 'Partly covered',
  uncovered: 'Needs cover',
}
